import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import SectionTitle from '../../../common/section-title/index';
import FileUpload from '../../../common/form/elements/file-upload';
import ArrowButton from '../../../common/button-arrow';
import FilesList from './downloads-list'
import {getFiles, uploadFile} from '../../../../actions/files'

import './styles.css'

class Downloads extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getFiles());
  }

  handleSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_files.upload', uploadFile(payLoad)))
      .then(() => {
        this.props.dispatch(getFiles());
        this.fileUpload.reset();
      });
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="files">
        <Row>
          <Col md={12}>
            <SectionTitle>Upload a new File</SectionTitle>
          </Col>
        </Row>
        <Row>
          <Form model="deep.admin_files.upload" onSubmit={this.handleSubmit}>
            <Col lg={6}>
              <FileUpload label="1. Choose a File"
                          ref={instance => {this.fileUpload = instance}}
                          required/>
            </Col>
            <Col lg={6}>
              <h4>2. Upload</h4>
              <ArrowButton ghost={false}>Upload file</ArrowButton>
            </Col>
          </Form>
        </Row>

        <Row>
          <Col md={12}>
            <SectionTitle>Download library</SectionTitle>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FilesList files={this.props.files}
                       fetching={this.props.fetching}
                       fetched={this.props.fetched}/>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    files:    state.files.list,
    fetching: state.files.fetching,
    fetched:  state.files.fetched
  };
};

export default connect(mapStateToProps)(Downloads);


// WEBPACK FOOTER //
// ./src/components/admin/downloads/list/index.jsx